import { GruppeStandort } from '../../gruppen/gruppe-standort-verwalten/gruppe-standort';
import { Haendler } from '../../stammdaten/haendler/haendler';
import { Tierliste } from '../classes/tierliste';
import { Betriebskontakt } from '../../stammdaten/betriebskontakte/betriebskontakt';

export class GruppeTierGewichtPreisDialogInput {
    einstallen = false;
    ausstallen = false;
    gruppeStandort: GruppeStandort;
    viehhaendler: Haendler;
    betriebskontakt: Betriebskontakt;
    /** API: yyyy-MM-dd strings (ISO Date JSON is not valid for MySQL DATE). */
    einstalldatums: Array<Date | string> = [];
    /** @deprecated Prefer tierlisten; kept for single-list callers. */
    tierliste: Tierliste;
    /** Selected Abgangslisten (one or more). */
    tierlisten: Tierliste[] = [];
}

export class GruppeStandortGewichtePreise {
    gs_id: number;
    gruppe_id: number;
    tierliste_id: number;
    einstall_tierliste_id: number;
    viehhaendler_id: number;
    betriebskontakt_haendler_id: number;
    /** API: yyyy-MM-dd strings (ISO Date JSON is not valid for MySQL DATE). */
    einstalldatums: Array<Date | string> = [];
    abgangsgewicht: number;
    kp_abgangspreis: number;
    kp_abgangsmwstsatz: number;
    einstallgewicht: number;
    kp_einstallpreis: number;
    kp_einstallmwstsatz: number;
    /** 'empty_only' | 'all' – see gruppe_tier_update_* procedures */
    overwrite_mode?: string;
}
